// import logo from './logo.svg';
// import './App.css';
// import Home from './pages/home/Home';
// import { BrowserRouter as Router, Route, Routes, Link, useNavigate } from 'react-router-dom';
// import NavbarComponent from './components/navbar/Navbar';
// import { useEffect, useState } from 'react';
// import About from './pages/about/About';
// import 'aos/dist/aos.css';
// import AOS from 'aos';
// import HrService from './pages/hr-service/HrService';


// function App() {
//   const [isRtl, setIsRtl] = useState(false);

//   const toggleLanguage = () => {
//     setIsRtl(!isRtl);
//     document.documentElement.setAttribute('dir', isRtl ? 'ltr' : 'rtl');
//   };


//   useEffect(() => {
//     AOS.init({
//       duration: 2000, // Animation duration in milliseconds
//     });
//   }, []);

//   return (
//     <>
//       <NavbarComponent toggleLanguage={toggleLanguage} isRtl={isRtl} />
//       <Routes>
//         <Route path="/" element={<Home isRtl={isRtl} toggleLanguage={toggleLanguage} />} />
//         <Route path="/about" element={<About isRtl={isRtl} toggleLanguage={toggleLanguage} />} />
//         <Route path="/hr-servies" element={<HrService isRtl={isRtl} toggleLanguage={toggleLanguage} />} />
//       </Routes>

//     </>
//   );
// }

// export default App;



import './App.css';
import Home from './pages/home/Home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavbarComponent from './components/navbar/Navbar';
import { useEffect, useState } from 'react';
import About from './pages/about/About';
import 'aos/dist/aos.css';
import AOS from 'aos';
import HrService from './pages/hr-service/HrService';
import FloatingButton from './components/floatingButton/FloatingButton';

function App() {
  const [isRtl, setIsRtl] = useState(true); // Set default language to Arabic (RTL)

  const [currentIndex, setCurrentIndex] = useState(0);
  const [pauseTransition, setPauseTransition] = useState(false);


  const toggleLanguage = () => {
    setIsRtl(!isRtl);
    document.documentElement.setAttribute('dir', isRtl ? 'ltr' : 'rtl'); // Toggle RTL/LTR
  };

  // Initialize AOS animations
  useEffect(() => {
    AOS.init({
      duration: 2000, // Animation duration in milliseconds
    });

    // Set initial direction to RTL on page load if isRtl is true
    document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
  }, [isRtl]);

  useEffect(() => {
    // Disable right-click
    const disableRightClick = (e) => e.preventDefault();

    // Add event listener for right-click and copy
    document.addEventListener('contextmenu', disableRightClick);
    document.addEventListener('copy', (e) => e.preventDefault());

    // Clean up listeners when the component unmounts
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener('copy', (e) => e.preventDefault());
    };
  }, []);

  return (
    <>
      <NavbarComponent toggleLanguage={toggleLanguage} isRtl={isRtl} setCurrentIndex={setCurrentIndex} setPauseTransition={setPauseTransition} />
      <Routes>
        <Route path="/" element={<Home isRtl={isRtl} toggleLanguage={toggleLanguage} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} pauseTransition={pauseTransition} />} />
        <Route path="/about" element={<About isRtl={isRtl} toggleLanguage={toggleLanguage} />} />
        <Route path="/hr-servies" element={<HrService isRtl={isRtl} toggleLanguage={toggleLanguage} />} />
      </Routes>
      <FloatingButton />
    </>
  );
}

export default App;
